import React from "react";
import { cn } from "@/utils";
import { sectionContainer } from "./services.module.css";
import { useStaticQuery, graphql } from "gatsby";
import { h2, pl } from "../ui/typography/typography.module.css";

interface TechStackProps extends React.HTMLProps<HTMLDivElement> {}
interface TechStack {
  name: string;
}
interface TechStackNode {
  tech_stack_clouds: TechStack[];
  back_ends: TechStack[];
  databases: TechStack[];
  testings: TechStack[];
  front_ends: TechStack[];
}
interface TechStackQuery {
  allStrapiTechStack: {
    edges: {
      node: TechStackNode;
    }[];
  };
}

const TechStack: React.FC<TechStackProps> = ({ className }) => {
  const data: TechStackQuery = useStaticQuery(graphql`
    query TechStackStrapi {
      allStrapiTechStack {
        edges {
          node {
            tech_stack_clouds {
              name
            }
            back_ends {
              name
            }
            databases {
              name
            }
            testings {
              name
            }
            front_ends {
              name
            }
          }
        }
      }
    }
  `);
  const techStackNodes = data.allStrapiTechStack.edges.map((edge) => edge.node);
  return (
    <>
      {techStackNodes.map((techStack, index) => (
        <div className={cn("flex flex-col md:flex-row md:gap-8", className)} key={index}>
          <div className={sectionContainer}>
            <h3 className={h2}>Front End</h3>
            <ul>
              {techStack.front_ends.map((frontEnd, frontEndIndex) => (
                <li key={frontEndIndex}>
                  <p className={pl}>{frontEnd.name}</p>
                </li>
              ))}
            </ul>
          </div>
          <div className={sectionContainer}>
            <h3 className={h2}>Back End</h3>
            <ul>
              {techStack.back_ends.map((backEnd, backEndIndex) => (
                <li key={backEndIndex}>
                  <p className={pl}>{backEnd.name}</p>
                </li>
              ))}
            </ul>
          </div>
          <div className={sectionContainer}>
            <h3 className={h2}>Cloud</h3>
            <ul>
              {techStack.tech_stack_clouds.map((cloud, cloudIndex) => (
                <li key={cloudIndex}>
                  <p className={pl}>{cloud.name}</p>
                </li>
              ))}
            </ul>
          </div>
          <div className={sectionContainer}>
            <h3 className={h2}>Testing</h3>
            <ul>
              {techStack.testings.map((testing, testingIndex) => (
                <li key={testingIndex}>
                  <p className={pl}>{testing.name}</p>
                </li>
              ))}
            </ul>
          </div>
          <div className={sectionContainer}>
            <h3 className={h2}>Database</h3>
            <ul>
              {techStack.databases.map((database, databaseIndex) => (
                <li key={databaseIndex}>
                  <p className={pl}>{database.name}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </>
  );
};

export default TechStack;
